import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Radio, Row, Table } from 'antd';

import {
  queryBusinessList,
  queryCustomDepartmentList,
  queryDepartmentMy,
  queryDepartmentOpportunity,
  querySaveBusiness,
} from '@api/crm/crm';
import ModalBusiness from './ModalBusiness';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pageNo: 1,
      stage: [],
      total: 0,
      custom: [],
      modalVisible: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getMyDepartment();
    this.getBusiness();
  }

  saveBusiness = params => {
    querySaveBusiness(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getBusiness();
        this.handleModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  getBusiness = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      pageNo: current,
    });
    queryBusinessList({
      condition: this.condition || '',
      type: this.type || '',
      start: current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  getMyDepartment = () => {
    queryDepartmentMy().then(res => {
      if (res.statusCode === 200) {
        const { uuid } = res.data;
        this.getStage(uuid);
        this.getMyCustom(uuid);
      }
    });
  };

  getMyCustom = () => {
    queryCustomDepartmentList().then(res => {
      this.setState({
        custom: res.data.customs,
      });
    });
  };

  getStage = uuid => {
    queryDepartmentOpportunity({
      uuid,
    }).then(res => {
      this.setState({
        stage: res.data,
      });
    });
  };

  handleModalVisible = (flag, uuid) => {
    this.uuid = uuid;
    this.setState({
      modalVisible: !!flag,
    });
  };

  handleModalEditVisible = (flag, uuid) => {
    this.uuid = uuid;
  };

  handleSubmit = params => {
    this.saveBusiness(params);
  };

  handleSearch = e => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      this.condition = values.condition;
      this.getBusiness(1);
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.condition = '';
    this.getBusiness(1);
  };

  handleChange = e => {
    const { value } = e.target;
    this.type = value === 'all' ? '' : value;
    this.getBusiness(1);
  };

  renderSearchForm = () => {
    const { stage } = this.state;
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSearch}>
        <FormItem label="阶段">
          <div>
            <Radio.Group defaultValue="a" buttonStyle="solid" onChange={this.handleChange}>
              <Radio.Button value="all">全部</Radio.Button>
              {stage.map(item => {
                return (
                  <Radio.Button value={item.name} key={item.name}>
                    {item.name}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          </div>
        </FormItem>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }} style={{ minWidth: '650px' }}>
          <Col md={8} sm={24} style={{ minWidth: '400px' }}>
            <FormItem label="客户名称">
              {getFieldDecorator('condition')(
                <Input placeholder="请输入" style={{ minWidth: '200px' }} />,
              )}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <a onClick={() => this.handleModalVisible(true, record.uuid)}>{index + 1}</a>;
        },
      },
      {
        title: '客户名称',
        dataIndex: 'customerName',
      },
      {
        title: '阶段',
        dataIndex: 'type',
      },
      {
        title: '预测百分比',
        dataIndex: 'percentage',
      },
      {
        title: '预测金额',
        dataIndex: 'prediction',
      },
    ];
  };

  render() {
    const { data, modalVisible, stage, custom, total, pageNo } = this.state;
    const parentProps = {
      handleModalVisible: this.handleModalVisible,
      handleSubmit: this.handleSubmit,
      stage,
      custom,
      uuid: this.uuid,
    };
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.getBusiness(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm()}</div>
          <div className="tableListOperator">
            <Button type="primary" onClick={() => this.handleModalVisible(true)}>
              添加
            </Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {modalVisible ? <ModalBusiness {...parentProps} /> : null}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/business/Index.js